// @module AAMS.OffersExtension.Offers.Mobile.Success.View
define('AAMS.OffersExtension.Offers.Mobile.Success.View'
,	[
		'aams_offersextension_offers_mobile_success.tpl'
    ]
, function (
		aams_offersextension_offers_mobile_success_tpl
)
{
    'use strict';

	// @class AAMS.OffersExtension.Offers.Mobile.Success.View @extends Backbone.View
	return Backbone.View.extend({

		template: aams_offersextension_offers_mobile_success_tpl

	,   modalClass: 'global-views-modal-small'	


	,	initialize: function (options) 
		{
			var { application } = options;
			//const profile_model = ProfileModel.getInstance();

      	}
		//@method getContext @return AAMS.OffersExtension.Offers.Mobile.Success.View.Context
	,	getContext: function getContext()
		{
			
			return {
				
			};
		}
	});
});
